import { render } from "./CourseHome.vue?vue&type=template&id=78c8be39&scoped=true"
import script from "./CourseHome.vue?vue&type=script&lang=js"
export * from "./CourseHome.vue?vue&type=script&lang=js"

import "./CourseHome.vue?vue&type=style&index=0&id=78c8be39&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c8be39"]])

export default __exports__